import axios from 'axios';

// URL de base de l'API selon l'environnement
const baseURL = process.env.NODE_ENV === 'production' 
  ? process.env.REACT_APP_API_URL || '/api'
  : 'http://localhost:5000/api';

// Créer une instance Axios
const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Intercepteur pour ajouter le token JWT (désormais géré par les cookies httpOnly)
api.interceptors.request.use(
  (config) => {
    // Le token est envoyé automatiquement via les cookies
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les erreurs de réponse
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log('API Error:', error.response?.status, error.response?.data);
    
    if (error.response?.status === 401) {
      console.log('401 error - token expired or invalid');
      
      // Vérifier si c'est spécifiquement un token expiré
      if (error.response?.data?.error === 'Token expiré') {
        console.log('Token expired - redirecting to login');
        // Optionnel : Afficher un message à l'utilisateur
        if (window.confirm('Votre session a expiré. Souhaitez-vous vous reconnecter ?')) {
          localStorage.removeItem('token');
          window.location = '/login';
        }
      } else {
        localStorage.removeItem('token');
        window.location = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;